import type { PanelWidth } from '../../split-layout/width-utils.js';
import type { LayoutMode } from '../details-layout/DetailsLayoutContext.js';

export const sidebarDefaults: {
  defaultWidth: PanelWidth;
  minWidth: PanelWidth;
  maxWidth: PanelWidth;
  resizable: boolean;
  defaultCollapsed: boolean;
  breakpoint: number;
} = {
  defaultWidth: '15%',
  minWidth: 200,
  maxWidth: '50%',
  resizable: true,
  defaultCollapsed: false,
  breakpoint: 960,
};

// The content pane reserves half the details region. In split this caps the
// details panel at ~50% (its old `maxWidth` default, expressed at the content
// layer); in overlay the panel floats, so the reserve does not constrain it.
export const contentDefaults: { minWidth: PanelWidth } = {
  minWidth: '50%',
};

export const detailsDefaults: {
  minWidth: PanelWidth;
  defaultWidth: PanelWidth;
  resizable: boolean;
  defaultCollapsed: boolean;
  defaultLayout: LayoutMode;
  breakpoint: number;
} = {
  minWidth: 320,
  defaultWidth: '25%',
  resizable: true,
  defaultCollapsed: false,
  defaultLayout: 'split',
  breakpoint: 600,
};
